// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FacultyCard_faculty-card__pIqxe {
  border-radius: 10px;
  padding: 15px 10px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  min-height: 190px;
  cursor: pointer;
  width: 100%;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb {
  min-height: 50px;
  display: flex;
  margin-bottom: 20px;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_avatar__5j3Fk {
  position: relative;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_avatar__5j3Fk .FacultyCard_photo__G10B\\+ {
  width: 70px;
  height: 70px;
  border-radius: 10%;
  object-fit: cover;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_avatar__5j3Fk .FacultyCard_check__h0rFV {
  position: absolute;
  width: 20px;
  height: 20px;
  object-fit: cover;
  left: 35px;
  top: 35px;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_name-title__Aydps {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_name-title__Aydps .FacultyCard_faculty-name__NHjrz {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  font-size: 16px;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_name-title__Aydps .FacultyCard_faculty-name__NHjrz p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_name-title__Aydps .FacultyCard_faculty-name__NHjrz {
  color: var(--blue);
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_name-title__Aydps .FacultyCard_title__a5Kaw {
  font-size: 10px;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_brief__xlSCb .FacultyCard_name-title__Aydps .FacultyCard_title__a5Kaw p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_institution__tqDyU {
  font-size: 10px;
  font-weight: bold;
}
.FacultyCard_faculty-card__pIqxe .FacultyCard_tag__EA5J4 {
  margin-top: 10px;
}
@media only screen and (max-width: 480px) {
  .FacultyCard_faculty-card__pIqxe {
    box-shadow: none;
    border: 1px solid var(--light-grey);
    min-height: 160px;
  }
  .FacultyCard_faculty-card__pIqxe .FacultyCard_institution__tqDyU {
    font-size: 14px;
    font-weight: bold;
  }
}

.FacultyCard_cited-by__6ZREl {
  font-size: 10px;
  color: var(--grey);
  font-weight: bold;
}

.FacultyCard_faculty-card__pIqxe:hover {
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}

.ant-carousel .slick-dots li.slick-active button {
  background-color: var(--explore-color) !important;
}

.ant-carousel .slick-dots li button {
  background-color: var(--light-pink) !important;
}

.ant-carousel .slick-prev {
  color: var(--explore-color) !important;
}

.ant-carousel .slick-next {
  color: var(--explore-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Components/FacultyCard/FacultyCard.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AACF;AAAE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AADI;EACE,kBAAA;AAGN;AAFM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAIR;AAFM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AAIR;AADI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAGN;AAFM;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;AAIR;AAHQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAKV;AAdM;EAWE,kBAAA;AAMR;AAJM;EACE,eAAA;AAMR;AALQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAOV;AAFE;EACE,eAAA;EACA,iBAAA;AAIJ;AAFE;EACE,gBAAA;AAIJ;AADE;EAhEF;IAiEI,gBAAA;IACA,mCAAA;IACA,iBAAA;EAIF;EAHE;IACE,eAAA;IACA,iBAAA;EAKJ;AACF;;AADA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AAIF;;AAFA;EACE,yCAAA;AAKF;;AAHA;EACE,iDAAA;AAMF;;AAJA;EACE,8CAAA;AAOF;;AALA;EACE,sCAAA;AAQF;;AANA;EACE,sCAAA;AASF","sourcesContent":[".faculty-card {\n  border-radius: 10px;\n  padding: 15px 10px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n  min-height: 190px;\n  cursor: pointer;\n  width: 100%;\n  .brief {\n    min-height: 50px;\n    display: flex;\n    margin-bottom: 20px;\n    .avatar {\n      position: relative;\n      .photo {\n        width: 70px;\n        height: 70px;\n        border-radius: 10%;\n        object-fit: cover;\n      }\n      .check {\n        position: absolute;\n        width: 20px;\n        height: 20px;\n        object-fit: cover;\n        left: 35px;\n        top: 35px;\n      }\n    }\n    .name-title {\n      display: flex;\n      flex-direction: column;\n      margin-left: 20px;\n      .faculty-name {\n        display: flex;\n        justify-content: space-between;\n        font-weight: bold;\n        font-size: 16px;\n        p {\n          display: -webkit-box;\n          -webkit-line-clamp: 3;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n        }\n        color: var(--blue);\n      }\n      .title {\n        font-size: 10px;\n        p {\n          display: -webkit-box;\n          -webkit-line-clamp: 3;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n        }\n      }\n    }\n  }\n  .institution {\n    font-size: 10px;\n    font-weight: bold;\n  }\n  .tag {\n    margin-top: 10px;\n  }\n\n  @media only screen and (max-width: 480px) {\n    box-shadow: none;\n    border: 1px solid var(--light-grey);\n    min-height: 160px;\n    .institution {\n      font-size: 14px;\n      font-weight: bold;\n    }\n  }\n}\n\n.cited-by {\n  font-size: 10px;\n  color: var(--grey);\n  font-weight: bold;\n}\n.faculty-card:hover {\n  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);\n}\n:global(.ant-carousel .slick-dots li.slick-active button) {\n  background-color: var(--explore-color) !important;\n}\n:global(.ant-carousel .slick-dots li button) {\n  background-color: var(--light-pink) !important;\n}\n:global(.ant-carousel .slick-prev) {\n  color: var(--explore-color) !important;\n}\n:global(.ant-carousel .slick-next) {\n  color: var(--explore-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faculty-card": `FacultyCard_faculty-card__pIqxe`,
	"brief": `FacultyCard_brief__xlSCb`,
	"avatar": `FacultyCard_avatar__5j3Fk`,
	"photo": `FacultyCard_photo__G10B+`,
	"check": `FacultyCard_check__h0rFV`,
	"name-title": `FacultyCard_name-title__Aydps`,
	"faculty-name": `FacultyCard_faculty-name__NHjrz`,
	"title": `FacultyCard_title__a5Kaw`,
	"institution": `FacultyCard_institution__tqDyU`,
	"tag": `FacultyCard_tag__EA5J4`,
	"cited-by": `FacultyCard_cited-by__6ZREl`
};
export default ___CSS_LOADER_EXPORT___;
